import { useState } from 'react'
import moment from 'moment'
import ReactDOM from 'react-dom'
import { isoDateFormat, isWithinAcceptableRange } from '../../../../infrastructure/date'

export function useDatePickerState(date: string | null, setDate: (newDate: String | null) => void, onError?: boolean) {
    let [isOnError, setIsOnError] = useState<boolean>(!!onError)

    function onChange(newDate: moment.Moment | null) {
        let newState = {
            date: null as string | null,
            isOnError: false
        }

        if (newDate !== null) {
            if (!newDate.isValid())
                newState.isOnError = true
            else {
                newState.isOnError = !isWithinAcceptableRange(newDate)
                // hack : this sets time to midnight UTC to avoid setting non-zero hours in date state
                newState.date = moment.utc(newDate.format(isoDateFormat)).toISOString()
            }
        }

        ReactDOM.unstable_batchedUpdates(() => {
            setDate(!newDate ? null : newState.date ?? date)
            setIsOnError(newState.isOnError)
        })
    }

    return { isOnError, setIsOnError, onChange }
}